export enum HotelAmenities {
  AccessibleOptions = 'accessibleoptions',
  BusinessService = 'businessservice',
  EvParking = 'evparking',
  FreeParking = 'freeparking',
  FreeTruckParking = 'freetruckparking',
  Frontdesk = 'frontdesk',
  Gym = 'gym',
  OnSiteParking = 'onsiteparking',
  Parking = 'parking',
  Reception24Hours = 'reception24hours',
  Restaurant = 'restaurant',
  SecuredParking = 'securedparking',
  Swimmingpool = 'swimmingpool',
  TruckParking = 'truckparking',
  Wifi = 'wifi',
}
